import FaIcon from '@fortawesome/ember-fontawesome/components/fa-icon';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { ExternalLink as ExternalLink$1 } from 'ember-primitives';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';
import templateOnly from '@ember/component/template-only';

const DefaultContent = setComponentTemplate(precompileTemplate("\n  <span>{{yield}}</span>\n\n  <FaIcon @icon={{faExternalLinkAlt}} />\n", {
  strictMode: true,
  scope: () => ({
    FaIcon,
    faExternalLinkAlt
  })
}), templateOnly());
const ExternalLink = setComponentTemplate(precompileTemplate("\n  <PrimitiveExternalLink class=\"inline-flex items-baseline gap-2 rounded-sm hover:underline focus:outline-none focus:ring-4 focus-visible:outline-none\" ...attributes>\n    {{#if (has-block)}}\n      <DefaultContent>\n        {{yield}}\n      </DefaultContent>\n    {{else if (has-block \"custom\")}}\n      {{yield DefaultContent to=\"custom\"}}\n    {{/if}}\n  </PrimitiveExternalLink>\n", {
  strictMode: true,
  scope: () => ({
    PrimitiveExternalLink: ExternalLink$1,
    DefaultContent
  })
}), templateOnly());

export { ExternalLink, ExternalLink as default };
//# sourceMappingURL=external-link.js.map
